import {components} from '../config/flavour'
import {useAppConfiguration} from '../shared/contexts/AppConfiguration'
import FooterComponent from './FooterComponent'
import {getCustomLandingPage} from './custom-landing-pages'

export default function HomePage() {
  const appConfig = useAppConfiguration()

  // Show loading state while config loads to avoid flash of default content
  if (!appConfig.loaded) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    )
  }

  // Check if a custom landing page is configured
  const customLandingPageKey = appConfig.appMetaData?.customLandingPage
  const CustomLandingPage = customLandingPageKey ? getCustomLandingPage(customLandingPageKey) : null

  return (
    <>
      {CustomLandingPage ? <CustomLandingPage /> : <components.HomePageContent />}
      <FooterComponent />
    </>
  )
}
